export const focusSubLinks = [
  { label: 'Climate Adaptive Agriculture', to: '/focus-area#Climate' },
  { label: 'Living Income', to: '/focus-area#Living' },
  { label: 'Greening Landscape', to: '/focus-area#Greening' },
  { label: 'Healthy Planet', to: '/focus-area#Healthy' },
];
